"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "How much does junk removal cost in Orleans?",
  answer: "Our pricing is based on the volume your items occupy in our truck. We provide free, no-obligation estimates on-site to ensure you get the most accurate and fair price for your specific removal needs."
}, {
  question: "Do you offer same-day service?",
  answer: "Yes, we often have availability for same-day or next-day pickups in the Orleans area. Contact us early in the day to secure your preferred time slot for fast and efficient service."
}, {
  question: "What types of items can you remove?",
  answer: "We handle almost everything from old furniture and appliances to construction debris and yard waste. As long as it's not hazardous material, our team can safely haul it away for you."
}, {
  question: "Do you recycle or donate items?",
  answer: "Sustainability is a priority for us. We sort through every load to ensure that usable furniture is donated to local charities and recyclable materials are taken to the proper processing facilities."
}, {
  question: "Which Orleans neighborhoods do you serve?",
  answer: "We proudly serve all of Orleans, including Convent Glen, Orléans Wood, Chatelaine Village, Fallingbrook, and Avalon. Our trucks are frequently in your neighborhood ready to help."
}];
export default function FaqOrleans() {
  return <section data-section-id="252312" id="faq-orleans" className="w-full flex flex-col bg-background text-foreground">
      {}
      <div className="bg-primary w-full py-20 md:py-32 flex items-center justify-center">
        <div className="bg-secondary px-8 py-4 md:px-12 md:py-6 rounded-lg shadow-lg">
          <h2 className="text-secondary-foreground text-5xl md:text-7xl font-default font-bold tracking-tight">
            FAQs
          </h2>
        </div>
      </div>

      {}
      <div className="w-full bg-gradient-to-b from-background to-accent/30 py-20 md:py-32 px-6 md:px-12">
        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="w-full space-y-10">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-none">
                <AccordionTrigger className="text-primary hover:text-primary/80 font-default font-semibold text-xl md:text-2xl text-left hover:no-underline py-0 [&>svg]:text-secondary [&>svg]:size-6">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-foreground/80 font-default text-base md:text-lg leading-relaxed pt-6 pb-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}